// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.plotInfo {
    cursor: help;
    float: right;
    position: relative;
    top: 2px;
}
.plotInfoNone {
    cursor: help;
    float: right;
    position: relative;
    top: 2px;
    opacity: 0.4;
}
`, "",{"version":3,"sources":["webpack://./src/components/helpers/plot-info.vue"],"names":[],"mappings":";AA0BA;IACA,YAAA;IACA,YAAA;IACA,kBAAA;IACA,QAAA;AACA;AAEA;IACA,YAAA;IACA,YAAA;IACA,kBAAA;IACA,QAAA;IACA,YAAA;AACA","sourcesContent":["<template>\n    <img v-if=\"description !== ''\" src=\"images/info32.png\" width=\"16\" height=\"16\" :class=\"plotInfoClass\" alt=\"\"\n         v-tooltip.right=\"{content: description}\">\n</template>\n<script>\nimport { VTooltip } from 'v-tooltip';\n\nexport default {\n    name: 'plot-info',\n    directives: {\n        tooltip: VTooltip\n    },\n    props: {\n        description: {\n            type: String,\n            required: true\n        }\n    },\n    computed: {\n        plotInfoClass() {\n            return this.description === '' ? 'plotInfoNone' : 'plotInfo';\n        }\n    }\n};\n</script>\n<style>\n.plotInfo {\n    cursor: help;\n    float: right;\n    position: relative;\n    top: 2px;\n}\n\n.plotInfoNone {\n    cursor: help;\n    float: right;\n    position: relative;\n    top: 2px;\n    opacity: 0.4;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
